import React from 'react';
import './Experience.css';

const Experience = () => {
  const experiences = [
    {
      company: "NUS Risk Society",
      role: "Director of Cyber Risk",
      period: "Aug 2025 - Current",
      bullets: [
        "Led inaugural Cyber Risk function and managed a team of 4 analysts to conduct cyber risk research.",
        "Set team direction, reviewed output quality, and consolidated findings into structured deliverables.",
        "Mentored analysts on research framing and translating technical concepts into risk insights."
      ]
    },
    {
      company: "Synapxe",
      role: "Cyber Risk Intern",
      period: "Jan 2025 - June 2025",
      bullets: [
        "Supported a Public Sector Data Security Review initiative via residual risk assessment templates.",
        "Contributed to a Cyber Risk Quantification PoC evaluating OpenFAIR to express risk in financial terms.",
        "Built a VBA-based forum tracker to streamline workflows, reducing manual effort."
      ]
    },
    {
      company: "Ministry of Defence (Singapore)",
      role: "Admin Support Assistant",
      period: "2020 - 2022",
      bullets: [
        "Built an RPA automation to transfer transcript write-ups into SAP, significantly reducing manual data entry.",
        "Coordinated exit processing across 10+ units and supported 1,000+ servicemen.",
        "Trained 4 colleagues to independently manage formations within 3 months."
      ]
    },
    {
      company: "Rotork Controls Singapore / Eezee Pte Ltd",
      role: "Engineering / Business Internships",
      period: "2017 - 2019",
      bullets: [
        "Assisted with FAT reports and warehouse coordination at Rotork Controls.",
        "Supported supplier onboarding and catalogued ~1,000 SKUs for a B2B marketplace at Eezee."
      ]
    }
  ];

  return (
    <section id="experience" className="experience-section">
      <h2 className="section-title">Professional Experience</h2>
      
      <div className="experience-timeline">
        {experiences.map((exp, idx) => (
          <div key={idx} className="exp-card glass-panel">
            <div className="exp-header">
              <div className="exp-title">
                <h3>{exp.role}</h3>
                <span className="company">{exp.company}</span>
              </div>
              <span className="period">{exp.period}</span>
            </div>
            <ul className="exp-bullets">
              {exp.bullets.map((bullet, i) => (
                <li key={i}>{bullet}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
